import { audioVisualizerInitCanvas, audioVisualizerPushSamples } from './audioCanvasRenderer'

const micSelectEl = document.getElementById('mic-select')! as HTMLSelectElement
const micStartEl = document.getElementById('mic-start') as HTMLButtonElement
let audioContext: AudioContext | null = null

async function loadDevices () {
  try {
    // Request permission first
    await navigator.mediaDevices.getUserMedia({ audio: true })

    const devices = await navigator.mediaDevices.enumerateDevices()
    const audioInputs = devices.filter(device => device.kind === 'audioinput')

    if (audioInputs.length === 0) {
      micSelectEl.innerHTML = '<option value="">No microphones found</option>'
      return
    }

    micSelectEl.innerHTML = ''
    audioInputs.forEach(device => {
      const option = document.createElement('option')
      option.value = device.deviceId
      option.textContent = device.label || `Microphone ${device.deviceId.slice(0, 8)}...`
      micSelectEl.appendChild(option)
    })
  } catch (error) {
    console.error('Error loading devices:', error)
    micSelectEl.innerHTML = '<option value="">Error loading devices</option>'
  }
}

let recordingStarted = false

async function startRecording () {
  if (recordingStarted) return

  try {
    const selectedDeviceId = micSelectEl.value
    if (!selectedDeviceId) {
      alert('Please select a microphone')
      return
    }

    audioContext = new AudioContext()
    const sampleRate = audioContext.sampleRate
    await audioContext.audioWorklet.addModule('./audioWorklet.js')

    // Get media stream from selected device
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      audio: {
        deviceId: { exact: selectedDeviceId },
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false
      }
    })

    // Create source node
    const sourceNode = audioContext.createMediaStreamSource(mediaStream)
    const workletNode = new AudioWorkletNode(audioContext, 'microphone-processor')
    workletNode.port.onmessage = (event) => {
      const outputData = event.data.outputData as Float32Array
      audioVisualizerPushSamples(outputData)
    }

    // Connect nodes
    sourceNode.connect(workletNode)
    workletNode.connect(audioContext.destination)

    recordingStarted = true
    audioVisualizerInitCanvas(sampleRate)
  } catch (error) {
    console.error('Error starting recording:', error)
  }
}

micStartEl.addEventListener('click', startRecording)
micSelectEl.addEventListener('focus', loadDevices)
